module.exports = __webpack_public_path__ + "img/40m2.1fbf5935.jpg";